import { apiRequest } from "./services";
import {
  persistAppLanguage,
  resolvePreferredAppLanguage,
  withAppLanguageOnUrl,
} from "./locale";

export function verificationContinueUrl(href, language) {
  return withAppLanguageOnUrl(
    href || (typeof window !== "undefined" ? window.location.href : ""),
    language
  );
}

export function preferredVerificationLanguage(i18nLanguage) {
  return persistAppLanguage(
    resolvePreferredAppLanguage({
      search: typeof window !== "undefined" ? window.location.search : "",
      stored:
        typeof window !== "undefined"
          ? window.localStorage.getItem("userLang")
          : null,
      i18nLanguage,
    })
  );
}

export async function sendAppVerificationEmail({
  uid,
  language,
  continueUrl,
  firstName,
} = {}) {
  if (!uid) return { error: "missing_user" };
  const lang = persistAppLanguage(language);
  return apiRequest(
    "users/send_verification_email",
    "POST",
    {
      user_id: uid,
      language: lang,
      continue_url: verificationContinueUrl(continueUrl, lang),
      first_name: firstName || undefined,
    },
    true,
    undefined,
    true
  );
}
